<div class="tables-row">
  <app-value-recognition-table
    [readonly]="readonly"
    title="default losses (unmitigated)"
    [tableInfo]="tablesInfo.defaultLossesTableInfo"
  ></app-value-recognition-table>
  <app-value-recognition-table
    [readonly]="readonly"
    title="default mitigation cost (DA)"
    [tableInfo]="tablesInfo.defaultMitigationCostTableInfo"
  ></app-value-recognition-table>
  <app-value-recognition-table
    [readonly]="readonly"
    title="clarifications"
    [tableInfo]="tablesInfo.clarificationsTableInfo"
  ></app-value-recognition-table>
</div>
<div class="tables-row">
  <app-value-recognition-table
    [readonly]="readonly"
    title="phase2"
    [tableInfo]="tablesInfo.phase2UrgencyXVulnerabilityTableInfo"
    [isUrgencyXVulnerability]="true"
  ></app-value-recognition-table>
  <app-value-recognition-table
    [readonly]="readonly"
    title="phase3"
    [tableInfo]="tablesInfo.phase3UrgencyXVulnerabilityTableInfo"
    [isUrgencyXVulnerability]="true"
  ></app-value-recognition-table>
  <app-value-recognition-table
    [readonly]="readonly"
    title="phase4"
    [tableInfo]="tablesInfo.phase4UrgencyXVulnerabilityTableInfo"
    [isUrgencyXVulnerability]="true"
  ></app-value-recognition-table>
</div>
